module.exports = __webpack_public_path__ + "static/media/object.58ca458a.gif";